/**
 * Menu component
 * 
 * @module component-menu
 * @version 1.0.0
 * @extends HTMLElement
 */

 customElements.component = 'component-menu';

 if (!customElements.get(customElements.component)) {

    class ComponentMenu extends HTMLElement {

        
    /**
     * Menu web component
     * 
     * @constructor
     */
    constructor() {

        super();

        this.closeMenu();
        this.initToggle();
        this.initSubmenu();

        if (window.screenMode == 'desktop' || window.screenMode == 'desktop-large' ) {
            let headerHeight = document.querySelector('header').clientHeight;
            let alertHeight = document.querySelector('#shopify-section-alert-message').clientHeight;

            this.setSubmenuOnTop(headerHeight, alertHeight);
        }
    }

    /**
	 * Init menu toggle buttons
     * 
     * @return {undefined}
	 */
    initToggle() {

        document.querySelectorAll('[data-menu-open]').forEach((element) => {

            element.addEventListener('click', (event) => {
                event.preventDefault();
                
                this.openMenu();
                this.activeToggle = event.target;
            });
        });

        document.querySelectorAll('[data-menu-close]').forEach((element) => {

            element.addEventListener('click', () => {
                this.closeMenu();
            });
        });

        // Close menu on window resize
        window.addEventListener('screen-breakpoint', event => {
            this.closeMenu();
        });

        // Close menu on press escape
        window.addEventListener('escape', event => {
            this.closeMenu();
        });

        const overlay = document.querySelector('[data-global-overlay]');

        // Close submenu when click on overlay
        overlay.addEventListener("click", (event) => {
        event.preventDefault();
        this.closeMenu();
      });

        // Close submenu when hover on overlay
        hoverintent(overlay, () => {
            this.closeMenu();
        }, () => {});
    }

    /**
	 * Open menu
     * 
     * @return {undefined}
	 */
    openMenu() {

        this.classList.remove('hidden');

        document.body.classList.add('overflow-hidden');
        document.body.classList.add('lg:overflow-auto');

        this.setAttribute('aria-hidden', 'false');

        this.openStatus = true;

        setTimeout(() => {

            this.classList.add('active');

            this.initFocusTrap();

            this.activeFocusTrap();
        
            this.querySelector('[data-menu-close]').focus();

        }, 50);   
    }

    /**
	 * Close menu
     * 
     * @return {undefined}
	 */
    closeMenu() {

        this.closeAllSubmenus();
        this.disableSubmenuFocusTrap();

        this.disableFocusTrap();

        this.classList.remove('active');

        document.body.classList.remove('overflow-hidden');
        document.body.classList.remove('lg:overflow-auto');

        if (window.screenMode == 'desktop-large') {

            this.setAttribute('aria-hidden', 'false');
            this.classList.remove('hidden');
            this.openStatus = true;

        } else {

            // We need to use set time out to avoid issues with menu animation
            setTimeout(() => {

                this.setAttribute('aria-hidden', 'true');

                if (this.openStatus && this.activeToggle) {
                    this.activeToggle.focus();
                }

                this.openStatus = false;

                this.classList.add('hidden');
            }, 50);
        } 
    }

    /**
	 * Init submenus
     * 
     * @return {undefined}
	 */
    initSubmenu() {

        this.closeAllSubmenus();

        // Open submenu on click
        document.querySelectorAll('[data-menu-submenu-target]').forEach((element) => {

            element.addEventListener('click', (event) => {
                
                if(window.screenMode != 'desktop-large') { 
                  event.preventDefault();
                }
                
                this.activeSubmenu = event.target;

                let submenu = document.querySelector('[data-menu-submenu="'+ element.dataset.menuSubmenuTarget + '"]');
                
                if(submenu.classList.contains("active")) {
                    this.closeSubmenu(submenu);
                } else {
                    this.openSubmenu(submenu);
                    if (window.screenMode == 'desktop-large') {
                    const menuRect = element.getBoundingClientRect();
                    const menuLeft = menuRect.left; 
                    submenu.style.left = menuLeft + 'px';
                    }
                }
            });
        });

        // Open submenu on hover only on desktop 
        document.querySelectorAll('[data-menu-level1-link]').forEach((element) => {

            if (element.dataset.menuSubmenuTargetHover) {

                hoverintent(element, () => {
                    
                    if (window.screenMode == 'desktop-large') {
    
                        let submenu = document.querySelector('[data-menu-submenu="'+ element.dataset.menuSubmenuTargetHover + '"]');
                        
                        this.openSubmenu(submenu, true).then(result => {});
                        
                        const menuRect = element.getBoundingClientRect();
                        
                        const menuLeft = menuRect.left;
 
                        submenu.style.left = menuLeft + 'px';
                    }
    
                }, () => { });

            } else {

                hoverintent(element, () => {                    
                    
                    if (window.screenMode == 'desktop-large') {
    
                        this.closeAllSubmenus();
                    }
    
                }, () => { });
            }
        });

        // Close submenu on click
        document.querySelectorAll('[data-menu-submenu-close-target]').forEach((element) => {

            element.addEventListener('click', (event) => {

                event.preventDefault();

                let submenu = document.querySelector('[data-menu-submenu="'+ element.dataset.menuSubmenuCloseTarget + '"]');

                this.closeSubmenu(submenu).then(result => {

                    this.disableSubmenuFocusTrap();

                    if (this.activeSubmenu) {
                        this.activeSubmenu.focus();
                        this.activeSubmenu = null;
                    }
                });

                this.disableGlobalOverlay();
            });
        });

        // Close submenu on leave hover only on desktop
        let siteHeader = document.querySelector('header');

        if(siteHeader) {
            siteHeader.addEventListener('mouseleave', (event) => {
                
                if (window.screenMode == 'desktop-large') {
                    this.closeAllSubmenus();
                    this.disableSubmenuFocusTrap();
                }
            });
        }
    }

    /**
	 * Open a submenu
     * 
     * @param {object} submenu A submenu object.
     * @param {boolean} disable_focus Disable focus change after open the submenu.
     * @return {Promise} Boolean value.
	 */
    openSubmenu(submenu, disable_focus = false) {

        return new Promise((resolve, reject) => {

            // Close all submenus opened
            this.closeAllSubmenus(submenu);

            // Handle submenu attributes
            submenu.classList.add('active');
            submenu.classList.add('animation');
            submenu.setAttribute('aria-hidden', 'false');
            submenu.classList.remove('hidden');

            // Handle global attributes
            this.classList.add('active-submenu');
            document.body.classList.add('overflow-hidden');
            document.body.classList.add('lg:overflow-auto');

            this.enableGlobalOverlay();
            
            // We need to use set time out to avoid issues with animation
            setTimeout(() => {
                
                if (!disable_focus) {
                    this.initSubmenuFocusTrap(submenu);
                    this.activeSubmenuFocusTrap();
                    submenu.querySelector('[data-menu-submenu-close-target]').focus();
                }

                resolve(true);
            }, 50);
        });
    }

    /**
	 * Close a submenu
     * 
     * @param {object} submenu A submenu object.
     * @return {Promise} Boolean value.
	 */
    closeSubmenu(submenu)  {

        return new Promise((resolve, reject) => {

            // Handle submenu attributes
            submenu.classList.remove('active');

            // Handle global attributes
            this.classList.remove('active-submenu');
            document.body.classList.remove('overflow-hidden');
            document.body.classList.remove('lg:overflow-auto');

            // We need to use set time out to avoid issues with animation
            setTimeout(() => {

                // Handle submenu attributes
                submenu.setAttribute('aria-hidden', 'true');
                submenu.classList.remove('animation');
                submenu.classList.add('hidden');
                resolve(true);
            }, 50);
        });
    }

    /**
	 * Close all submenus
     * 
     * @param {object} submenuActived The active submenu.
     * @return {undefined}
	 */
    closeAllSubmenus(submenuActived)  {

        let submenus = document.querySelectorAll('[data-menu-submenu]');

        submenus.forEach(submenu => {

            if (submenuActived) {

                // This condition will avoid to close the active submenu
                if (submenuActived.dataset.menuSubmenu != submenu.dataset.menuSubmenu) {
                    this.closeSubmenu(submenu);
                }

            } else {
            
                this.closeSubmenu(submenu);
            }
        });

        this.disableGlobalOverlay();
    }

    /**
	 * Enable global overlay
     * 
     * @return {undefined}
	 */
    enableGlobalOverlay()  {

        if (window.screenMode == 'desktop-large') {
            document.querySelector('[data-global-overlay]').classList.add('active');
            document.querySelector('[data-global-overlay]').classList.remove('hidden');
        }
    }

    /**
	 * Disable global overlay
     * 
     * @return {undefined}
	 */
    disableGlobalOverlay() {

        if (window.screenMode == 'desktop-large') {
            document.querySelector('[data-global-overlay]').classList.remove('active');
            document.querySelector('[data-global-overlay]').classList.add('hidden');
        }
    }

    /**
	 * Init menu focus trap
     * 
     * @return {undefined}
	 */
    initFocusTrap() {

        this.focusTrap = focusTrap.createFocusTrap(this, {});
    }

    /**
	 * Disable menu focus trap
     * 
     * @return {undefined}
	 */
    disableFocusTrap() {

        if (this.focusTrap) {
            this.focusTrap.deactivate();
        }
    }

    /**
	 * Ative menu focus trap
     * 
     * @return {undefined}
	 */
    activeFocusTrap() {

        if (this.focusTrap) {
            this.focusTrap.activate();
        }
    }

    /**
	 * Init submenu focus trap
     * 
     * @return {undefined}
	 */
    initSubmenuFocusTrap(submenu)  {

        this.submenuFocusTrap = focusTrap.createFocusTrap(submenu, { clickOutsideDeactivates: true });
    }

    /**
	 * Active submenu focus trap
     * 
     * @return {undefined}
	 */
    activeSubmenuFocusTrap()  {
        
        if (this.submenuFocusTrap) {

            this.disableFocusTrap();
            this.submenuFocusTrap.activate();
        }
    }

    /**
	 * Disable submenu focus trap
     * 
     * @return {undefined}
	 */
    disableSubmenuFocusTrap() {
        
        if (this.submenuFocusTrap) {
            
            this.submenuFocusTrap.deactivate();
            this.submenuFocusTrap = null;

            if (window.screenMode != 'desktop-large') {
                this.initFocusTrap();
                this.activeFocusTrap();
            }
        }
    }

     /**
	 * Set submenu on top
     * 
     * @return {undefined}
	 */
    setSubmenuOnTop(headerHeight, alertHeight) {

        let fullHeight = (alertHeight + headerHeight) - 7;

        document.querySelectorAll('[data-menu-submenu]').forEach(submenu => {
            submenu.style.top = fullHeight + "px";
        });

        document.addEventListener('scroll', () => {
            if (window.pageYOffset > alertHeight ) {
                document.querySelectorAll('[data-menu-submenu]').forEach(submenu => {
                    submenu.style.top = headerHeight + "px";
                });
            } else {
                document.querySelectorAll('[data-menu-submenu]').forEach(submenu => {
                    submenu.style.top = fullHeight + "px";
                });
            }
        });

    }
}

customElements.define(customElements.component, ComponentMenu);

}